import { Injectable } from '@angular/core';

import { HashmapStateBase } from 'src/app/shared/state/hashmap-state-base';
import {
  StateManager,
  taskDetailsStateFactory,
} from './task-details-base.state';

@Injectable({
  providedIn: 'root',
})
export class TaskDetailsHashmapState extends HashmapStateBase<StateManager> {
  protected override createState(): StateManager {
    return taskDetailsStateFactory();
  }
}
